<template>
  <el-container>
    <el-header>
      <el-col :span="24">
        <span>{{ $t('informe.sde') }}</span>
      </el-col>
    </el-header>
    <el-main>
      <el-form :label-position="labelPosition">
        <el-row :gutter="4">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('informe.initialDate')">
              <el-date-picker
                v-model="fecha_inicial"
                format="yyyy/MM/dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('informe.endDate')">
              <el-date-picker
                v-model="fecha_final"
                format="yyyy/MM/dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-button type="primary" @click="obtenerDatos()">{{
              $t('informe.process')
            }}</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col>
          <el-table
            :data="tableData"
            width="100%"
            height="600px"
            stripe
            v-loading="loading"
          >
            <el-table-column label="Tipo" prop="Tipo" width="50">
            </el-table-column>
            <el-table-column
              label="Fecha solucion"
              prop="Fecha solucion"
              width="120"
            >
            </el-table-column>
            <el-table-column
              label="Fecha digitacion"
              prop="Fecha digitacion"
              width="150"
            >
            </el-table-column>
            <el-table-column
              label="Reporte tecnico"
              prop="Reporte tecnico"
              width="150"
            >
            </el-table-column>
            <el-table-column label="Descripción" prop="Descripcion" width="500">
            </el-table-column>
            <el-table-column
              label="Codigo luminaria"
              prop="Codigo luminaria"
              width="150"
            >
            </el-table-column>
            <el-table-column
              label="Codigo de apoyo"
              prop="Codigo de apoyo"
              width="150"
            >
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <img
            :title="$t('xls')"
            @click="exportarXls()"
            style="width: 32px; height: 36px; cursor: pointer;"
            :src="require('@/assets/xls.png')"
          />
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { parseTime } from '@/utils'
  import { get_report_detail_expansion } from '@/api/reporte_python'
  import XLSX from 'xlsx'
  export default {
    data() {
      return {
        labelPosition: 'top',
        fecha_inicial: new Date(),
        fecha_final: new Date(),
        tableData: [],
        loading: false
      }
    },
    computed: {
      ...mapGetters(['empresa', 'usuario'])
    },
    methods: {
      obtenerDatos() {
        this.loading = true
        get_report_detail_expansion(
          this.fecha_inicial.getTime(),
          this.fecha_final.getTime(),
          this.empresa.empr_id
        )
          .then(response => {
            this.loading = false
            this.tableData = response.data
          })
          .catch(error => {
            this.loading = false
            console.log('Error Expansión: ' + error)
          })
      },
      exportarXls() {
        this.downloadLoading = true
        const items = this.tableData
        const header = Object.keys(items[0])
        let wscols = []

        for (let i = 0; i < header.length; i++) {
          wscols.push({ wch: header[i].length + 15 })
        }

        let data = XLSX.utils.json_to_sheet(items)
        data['!cols'] = wscols
        const wb = XLSX.utils.book_new()
        let fileName =
          'expansion_' +
          this.$moment(this.fecha_inicial).format('YYYYMMDD') +
          '_' +
          this.$moment(this.fecha_final).format('YYYYMMDD')
        XLSX.utils.book_append_sheet(wb, data, fileName)
        XLSX.writeFile(wb, fileName + '.xlsx')
        this.downloadLoading = false
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v =>
          filterVal.map(j => {
            if (j === 'timestamp') {
              return parseTime(v[j])
            } else {
              return v[j]
            }
          })
        )
      }
    }
  }
</script>
<style lang="scss" scoped>
  .fa-icon {
    width: auto;
    height: 1em; /* or any other relative font sizes */

    /* You would have to include the following two lines to make this work in Safari */
    max-width: 100%;
    max-height: 100%;
  }
</style>
